import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/context/AuthContext";

const DEFAULTS = {
  founder: {
    name: "Wilson Eric",
    role: "Fondateur, Whilsco-Digit",
    bio:
      "Ingénieur de formation et project manager depuis plus d'une décennie, Wilson Eric appartient à cette génération de Béninois formés à l'exigence de la tech internationale. Né et grandi au Bénin, éprouvé en France, il y a passé plusieurs années à piloter des produits digitaux pour de grandes entreprises européennes — avant de revenir aux questions qui le portent vraiment.\n\nEntrepreneur dans l'âme, il est également à l'initiative d'Ourbeauty Bénin, une marque de cosmétiques 100 % locale bâtie autour du lait de chèvre et d'ânesse — convaincu que le savoir-faire béninois peut se mesurer aux meilleures marques internationales.\n\nUn constat s'impose en rentrant chez lui : les commerçants, les vendeurs et les livreurs indépendants du Bénin méritent des outils à leur mesure. Aucune raison d'attendre qu'une solution vienne de l'extérieur — un Béninois peut la faire. C'est ainsi qu'il fonde Whilsco-Digit SARL et lance Zafara, l'application locale taillée pour les usages du pays.",
    quote: "Un Béninois peut la faire.",
    email: "i.wilson@whilsco.fr",
    linkedin: "",
    twitter: "",
    photo: "",
  },
  company: {
    form: "SARL",
    siege: "Île Maurice",
    rccm: "",
    ifu: "",
    whatsapp: "+229 01 97 65 75 44",
    email: "i.wilson@whilsco.fr",
    hebergeur: "",
  },
  stores: {
    appStore: "https://apps.apple.com/bj/app/afrimarket/id6761389833?l=fr-FR",
    playStore: "https://play.google.com/store/apps/details?id=app.zafara",
  },
  hero: {
    badge: "Local · Rapide · De confiance",
    line1: "Née au",
    highlight: "Bénin.",
    line2: "Faite pour",
    line3: "aller loin.",
    paragraph:
      "Zafara est pensée pour votre ville et vos usages. Une app locale, rapide, faite pour tous les commerces, les vendeurs et livreurs indépendants du Bénin.",
  },
  whyBlocks: [
    { letter: "ZA", title: "La sonorité de l'Afrique.", text: "On l'entend dans toutes nos langues, du Bénin au reste du continent. Un son familier qui traverse les frontières." },
    { letter: "FAR", title: "Aller loin.", text: "Emprunté à l'anglais, « far » porte l'ambition. Ne pas se limiter à un pays, à une ville, à un quartier. Voir grand." },
    { letter: "A", title: "Accessible.", text: "À tout le monde, partout. Pas d'élitisme. Une appli faite pour la dame du marché comme pour la diaspora." },
  ],
  appFeatures: [
    { icon: "Store", title: "Les commerces de votre quartier, en un tap.", text: "Boutiques, épiceries, services, artisans : trouvez et joignez d'un geste ceux qui comptent près de chez vous." },
    { icon: "Truck", title: "Faite pour les vendeurs et livreurs indépendants.", text: "Un espace juste, des outils simples, une visibilité immédiate. Zafara donne aux vendeurs et aux livreurs indépendants du Bénin les moyens de vivre de leur travail." },
    { icon: "Zap", title: "Rapide, même en zone 3G.", text: "Interface légère, chargements instantanés. Zafara est optimisée pour fonctionner correctement dès la 3G, partout au Bénin." },
    { icon: "ShieldCheck", title: "De confiance, dès le premier usage.", text: "Avis vérifiés, coordonnées confirmées, paiements sécurisés. Aucune place pour les mauvaises surprises." },
  ],
};

const ContentContext = createContext({ content: DEFAULTS, refresh: () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULTS);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent({
        founder: { ...DEFAULTS.founder, ...(data.founder || {}) },
        company: { ...DEFAULTS.company, ...(data.company || {}) },
        stores: { ...DEFAULTS.stores, ...(data.stores || {}) },
        hero: { ...DEFAULTS.hero, ...(data.hero || {}) },
        whyBlocks: Array.isArray(data.whyBlocks) && data.whyBlocks.length ? data.whyBlocks : DEFAULTS.whyBlocks,
        appFeatures: Array.isArray(data.appFeatures) && data.appFeatures.length ? data.appFeatures : DEFAULTS.appFeatures,
      });
    } catch {
      // Keep defaults on failure
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <ContentContext.Provider value={{ content, refresh: load }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
